import { getSystemAddressLine } from '../../Systems/components/FilterModal/filterUtils';
import { SystemStatuses } from '../components/Filtering'; // FIXME: bad dependency
import type { ISystem } from '../types';

export const mapSystems = (_: ISystem) => ({
  ..._,
  addressLineOne: getSystemAddressLine(_),
  statuses: [
    _.online ? SystemStatuses.ONLINE : SystemStatuses.OFFLINE,
    _.online && _.alarms.length === 0 && SystemStatuses.WITHOUT_ALERT,
    _.onlineFirmwareUpdateAvailable && SystemStatuses.HAS_FW_UPDATE,
    _.onlineNotification && SystemStatuses.HAS_NOTIFICATION,
    _.onlineAlert && SystemStatuses.HAS_ALARM,
  ].filter(Boolean),
});
